
jQuery($ => {
	const Masonry = require('masonry-layout');
	const cards = document.querySelector('.masonry');

	if($('.masonry').length){
		window.masonryCards = new Masonry( cards, {
			columnWidth: '.masonry-sizer',
		  	itemSelector: '.card',
		  	horizontalOrder: true,
			percentPosition: true,
			transitionDuration: '0.2s',
			gutter: 15
		});
		$(window).bind('load', function(){
			window.masonryCards.reloadItems();

			setTimeout(function(){
				window.masonryCards.layout();
			}, 350);
		});
	}

});
